import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { KeycloakUserRole } from '@libs/shared/interface/enum';
import { AuthService } from '@sprint-expert-manager/app/core/auth/auth.service';
import { map, Observable } from 'rxjs';

@Injectable()
export class AuthGuard {
  readonly authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      map(x => {
        if (x) {
          // Get the roles required from the route.
          const requiredRoles = route.data.roles as string[];

          // Allow the user to proceed if no additional roles are required to access the route.
          if (!(requiredRoles instanceof Array) || requiredRoles.length == 0) {
            return true;
          }

          // Allow the user to proceed if one of the roles matched.
          return requiredRoles.some((role: KeycloakUserRole) =>
            this.authService.getRealmRoles().includes(role)
          );
        }
        return false;
      })
    );
  }
}
